import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Func from "../helpers/functions";
import * as Types from '../constants/Types';
import i18n from '../constants/initLng';
import {exportBundleReportExcelService} from '../services/reportService'

function* exportBundleReportExcel() {
    yield takeLatest(Types.EXPORT_BUNDLE_REPORT_EXCEL, Func.sagaWrapper(function* (action) {
        const result = yield call(exportBundleReportExcelService, action.params);
        downloadFileExcel(result);
        Func.sagaSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({type: Types.EXPORT_BUNDLE_REPORT_EXCEL_SUCCESS})
    }, errorHandleBundleReport(Types.EXPORT_BUNDLE_REPORT_EXCEL_FAIL)))
}

function errorHandleBundleReport(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'bundleReport');
}

function downloadFileExcel(result) {
    const fileName = result.headers['x-suggestion-filename'];
    const fileType = result.headers['content-type'];
    Func.downloadFile(result.data, fileName, { type: fileType });
}

export function* bundleReportSaga() {
    yield all([
        fork(exportBundleReportExcel),
    ])
}